module.exports = __webpack_public_path__ + "static/media/Image1BG@2x.7df7d0ca.png";